import { defineMessages } from 'react-intl';

import SearchSchema from './schema';
import SearchBlockEdit from './SearchBlockEdit';
import SearchBlockView from './SearchBlockView';

import searchSVG from '@plone/volto/icons/zoom.svg';

defineMessages({
  spacing: {
    id: 'Spacing',
    defaultMessage: 'Spacing',
  },
  listingWithFilters: {
    id: 'Listing with Filters',
    defaultMessage: 'Listing with Filters',
  },
});

defineMessages({
  spacing: {
    id: 'Spacing',
    defaultMessage: 'Spacing',
  },
});

const applyConfig = (config) => {
  config.blocks.blocksConfig.customSearch = {
    id: 'customSearch',
    title: 'Listing with Filters',
    icon: searchSVG,
    group: 'listing',
    view: SearchBlockView,
    edit: SearchBlockEdit,
    blockSchema: SearchSchema,
    restricted: false,
    mostUsed: false,
    sidebarTab: 1,
  };
  return config;
};

export default applyConfig;
